import {IStrapiEntity, StrapiUtils} from "services/strapi";
import {ListItemsTable, ListItemsTableProps} from "components/common";
import {RoutesResolver} from "routes";
import {IQuoteVersion, TableSettings} from "features/quote-versions";

interface Props extends Omit<ListItemsTableProps<
    IQuoteVersion & { id: number },
    void>,
    'settings' | 'data'> {

    data?: IStrapiEntity<IQuoteVersion>[]
}

export function QuoteVersionsListTable({data, ...rest}: Props){
    const routesResolver = new RoutesResolver()
    return (
        <ListItemsTable
            {...rest}
            data={StrapiUtils.flattenStrapiEntities(data)}
            settings={TableSettings({
                routesResolver,
            })}
        />
    )
}